const style = document.createElement("style");
style.textContent = "nextjs-portal{display:none!important}";
document.documentElement.appendChild(style);
